import React, { useEffect, useState } from 'react';
import './Tokens.scss';
import { connect } from 'react-redux';
import {
  filterTokensAction,
  getTokensActionRequest,
  sortTokensAction,
} from '../../store/token/tokenActions';
import MercurXTokenTable from '../../components/MercurXTokenTable/MercurXTokenTable';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function Tokens({
  getTokensRequest,
  sortTokens,
  filterTokens,
}) {
  const history = useHistory();
  const [filterInput, setFilterInput] = useState('');
  const user = JSON.parse(localStorage.getItem('user'))?.user;
  useEffect(() => {
    getTokensRequest();
  }, [getTokensRequest]);

  useEffect(() => {
    filterTokens(filterInput);
    sortTokens();
  }, [filterInput, filterTokens, sortTokens]);

  function createNewToken() {
    history.push('/tokens/create-new-token');
  }

  return (
    <>
      <div className="text-fs-head-md mb-4">Tokens</div>
      <Row className="text-fs-body-md mt-4 text-center">
        <Col>
          <Form.Control
            className="text-fs-body-sm"
            type="text"
            placeholder="Search by token name, token symbol or token contract adress..."
            aria-label="text"
            aria-describedby="basic-addon1"
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            size={'sm'}
          />
        </Col>
      </Row>
      <div id="tokens-container" className="mt-4">
        <MercurXTokenTable />
      </div>
      <div className="text-end">
      {user.is_superuser && (
        <Button onClick={createNewToken} size={'sm'}>
          Create new token
        </Button>
        )}
      </div>
    </>
  );
}
const mapDispatchToProps = (dispatch) => {
  return {
    getTokensRequest: (payload) => {
      dispatch(getTokensActionRequest(payload));
    },
    sortTokens: (payload) => {
      dispatch(sortTokensAction(payload));
    },
    filterTokens: (payload) => {
      dispatch(filterTokensAction(payload));
    },
  };
};

export default connect(null, mapDispatchToProps)(Tokens);
